import { PayloadAction } from '@reduxjs/toolkit';
import { validate } from 'main/store/_utils/reducer';
import { ContactState, nameSchema, emailSchema, detailsSchema } from '../state';

export const changeName = (state: ContactState, action: PayloadAction<string>) => {
    state.name.value = action.payload;
    state.name.errors = validate(nameSchema, action.payload);
}

export const changeEMail = (state: ContactState, action: PayloadAction<string>) => {
    state.email.value = action.payload;
    state.email.errors = validate(emailSchema, action.payload);
}

export const changeDetails = (state: ContactState, action: PayloadAction<string>) => {
    state.details.value = action.payload;
    state.details.errors = validate(detailsSchema, action.payload);
}

export const clearContact = (state: ContactState, _: PayloadAction) => {
    state.name.value = '';
    state.email.value = '';
    state.details.value = '';
}
